var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.8vw",
    height: "1.7vw",
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 34,
    rx: 5,
    fill: "#50C878"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3949 14.882L15.9599 15.3125L15.8369 15.8825L16.5119 16.007C16.9529 16.112 17.0399 16.271 16.9439 16.7105L15.8369 21.9125C15.5459 23.258 15.9944 23.891 17.0489 23.891C17.8664 23.891 18.8159 23.513 19.2464 22.994L19.3784 22.37C19.0784 22.634 18.6404 22.739 18.3494 22.739C17.9369 22.739 17.7869 22.4495 17.8934 21.9395L19.3949 14.882ZM19.4999 11.75C19.4999 12.1478 19.3419 12.5294 19.0606 12.8107C18.7793 13.092 18.3978 13.25 17.9999 13.25C17.6021 13.25 17.2206 13.092 16.9393 12.8107C16.658 12.5294 16.4999 12.1478 16.4999 11.75C16.4999 11.3522 16.658 10.9706 16.9393 10.6893C17.2206 10.408 17.6021 10.25 17.9999 10.25C18.3978 10.25 18.7793 10.408 19.0606 10.6893C19.3419 10.9706 19.4999 11.3522 19.4999 11.75Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/InfoIcon.bf79f4c07a65807b4ff77ec6f070e41f.svg";
export { ForwardRef as ReactComponent };